import { deleteSupplier } from '../../../HttpRequests/suppliers';
import { setSubmitting } from '../State/submitting';
import handleException from '../../../Core/Helpers/handleException';
import { message, Modal } from 'antd';
import { getProps } from '../props';

const { confirm } = Modal;

export default () => async (dispatch, getState) => {

  const { onClose, didDelete } = getProps();
  const { supplier } = getState().modals.Supplier;

  if (!supplier) return;

  confirm({
    title: 'Are you sure you want to delete this supplier?',
    content: 'This action cannot be undone.',
    okText: 'Yes, delete',
    okType: 'danger',
    cancelText: 'Cancel',
    onOk: async () => {
      try {
        dispatch(setSubmitting(true));
        await deleteSupplier({ id: supplier.id });
        message.success('Supplier deleted successfully');
        if (didDelete) didDelete();
        if (onClose) onClose();
      } catch (error) {
        handleException(error);
      } finally {
        dispatch(setSubmitting(false));
      }
    },
  });
}
